import * as React from 'react';
export function useTimer(interval, callback) {
    React.useEffect(() => {
        const id = setInterval(callback, interval);
        return () => clearInterval(id);
    }, [interval, callback]);
}
